export default __webpack_public_path__ + "static/media/937498ddb33eb0355a81b159091f260a.jpg";